"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpClient = _interopRequireDefault(require("../httpClient"));

var _default = {
  getConfig: function getConfig(senderEntityId) {
    return _httpClient.default.get('/gateway/message-center/config', {
      params: {
        path: 'poller'
      },
      headers: {
        'X-ANGI-CallerId': senderEntityId
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/poller/pollerService.js
// module id = 4485
// module chunks = 25